import React from 'react';

/** Shown while async route guards (e.g. dev whoami) resolve. */
const RouteGuardSpinner: React.FC = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div
      className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600"
      aria-label="Loading"
      role="status"
    />
  </div>
);

export default RouteGuardSpinner;
